<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="hideNdcObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }}</p>
                    <p>Trigger for NDC flights</p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="hideNdcObj.isActive" v-model="hideNdcObj.isActive"
                        @input="hideNdc" :left-label="true">{{ hideNdcObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>

        <StandardRuleActions v-if="hideNdcObj.isActive" :ruleObj="hideNdcObj" :title="title" @save="updateActions" />
    </div>
</template>
<script>
import StandardRuleActions from "../StandardRuleActions.vue";

export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: {
        StandardRuleActions
    },
    data() {
        return {
            hideNdcObj: this.value
                ? this.value
                : {
                    name: "hideNdc",
                    isActive: false,
                    type: "air",
                    message: "Trigger for NDC flights",
                },
            title: "NDC Flights",
        };
    },
    methods: {
        hideNdc() {
            if (!this.hideNdcObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            }

            this.emitRuleObj();
        },
        clearActionParams() {
            // Reset to default actions when rule is not active ()
            this.hideNdcObj.useCustomActions = false;
            delete this.hideNdcObj.visibility;
            delete this.hideNdcObj.approvalLevel;
            delete this.hideNdcObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into hideNdcObj
            this.hideNdcObj = { ...this.hideNdcObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams()
            }

            this.emitRuleObj();
        },
        emitRuleObj() {
            this.$emit("hideNdc", this.hideNdcObj);
        },
    },
    mounted() {
        this.hideNdcObj.type = "air";

        this.emitRuleObj();
    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                if (this.value) {
                    this.hideNdcObj = this.value;
                }
                this.hideNdcObj.type = "air";

                this.emitRuleObj();

            },
            deep: true,
        },
    },
};
</script>